import type { RequestStatusGroup } from "@productlane/lib/src/support-requests"
import { groupRequestsByStatus } from "@productlane/lib/src/support-requests"

interface IssueLike {
	id: string
	status?: string | null
	statusName?: string | null
}

interface ProjectLike {
	id: string
	state?: string | null
}

export type IssueOrProjectRow<I, P> =
	| { type: "issue"; category: "open"; item: I }
	| { type: "project"; category: "open"; item: P }

// Same sections and order as the support portal, so a customer page and its
// portal preview read alike. Input order is kept within each group.
export function groupIssuesAndProjects<
	I extends IssueLike,
	P extends ProjectLike,
>(
	issues: readonly I[],
	projects: readonly P[],
): RequestStatusGroup<IssueOrProjectRow<I, P>>[] {
	return groupRequestsByStatus<IssueOrProjectRow<I, P>>([
		...projects.map((item) => ({
			type: "project" as const,
			category: "open" as const,
			item,
		})),
		...issues.map((item) => ({
			type: "issue" as const,
			category: "open" as const,
			item,
		})),
	])
}
